"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBVLoader = exports.useBVLoader = exports.BVLoaderProvider = void 0;

var react_1 = __importStar(require("react"));

var getBVScriptUrl_1 = __importDefault(require("../getBVScriptUrl"));

var defaultValue = {
  isLoaded: false
};
var BVLoaderContext = react_1.default.createContext(defaultValue);

exports.BVLoaderProvider = function (_a) {
  var children = _a.children,
      scriptUrl = _a.scriptUrl;

  var _b = react_1.useState(false),
      isLoaded = _b[0],
      setIsLoaded = _b[1];

  react_1.useEffect(function () {
    var scriptId = 'bvloader';

    if (!document.getElementById(scriptId)) {
      var scriptUrl$ = scriptUrl || getBVScriptUrl_1.default();
      var script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.async = true;
      script.src = scriptUrl$;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  });
  react_1.useEffect(function () {
    var timer = setInterval(function () {
      // @ts-ignore
      if (typeof $BV !== 'undefined') {
        clearInterval(timer);
        setIsLoaded(true);
      }
    }, 200);
    return function () {
      return clearInterval(timer);
    };
  });
  return react_1.default.createElement(BVLoaderContext.Provider, {
    value: {
      isLoaded: isLoaded
    }
  }, children);
};

exports.useBVLoader = function () {
  return react_1.useContext(BVLoaderContext);
};

exports.withBVLoader = function (Component) {
  return function (props) {
    return react_1.default.createElement(exports.BVLoaderProvider, null, react_1.default.createElement(Component, __assign({}, props)));
  };
};